import { Time } from '@angular/common';

export class AddressModel {

	addreId: number;

	addreVaDistrict: string;

	addreVaLatitude;

	addreVaLine1: string;

	addreVaLine2: string;

	addreVaLongitude;

	addreVaPostalCode: string;

	addreVaZone: string;

	cotryId: number;

	//createdTime: Time;

	createdUser: string;

	//modifiedTime: Time;

	modifiedUser: string;

	townId: number;

	addressType:string;

	partnerId:number;
	
	partnerType:number;

	countryName : string;

	townName: string;

	phone :number;
	typeId : number;


}